import type { Theme } from "theme-ui"

const theme: Theme = {
  colors: {
    text: "#ffffff",
    background: "#1a0933",
    primary: "#191B4B",
    secondary: "#7209b7",
    accent: "#560bad",
    highlight: "#b5179e",
    muted: "#480ca8",
  },
  fonts: {
    // Updated to use Montserrat with Inter as fallback
    body: '"Montserrat", "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    heading: '"Montserrat", "Inter", inherit',
  },
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72],
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  sizes: {
    container: 1200,
  },
  buttons: {
    primary: {
      color: "white",
      bg: "primary",
      borderRadius: "30px",
      fontWeight: "bold",
      py: 2,
      px: 4,
      "&:hover": {
        bg: "highlight",
      },
    },
    secondary: {
      color: "white",
      bg: "transparent",
      border: "1px solid white",
      borderRadius: "30px",
      fontWeight: "bold",
      py: 2,
      px: 4,
      "&:hover": {
        bg: "rgba(255,255,255,0.1)",
      },
    },
  },
  styles: {
    root: {
      fontFamily: "body",
      lineHeight: "body",
      fontWeight: "body",
      color: "text",
      bg: "background",
    },
    h1: {
      color: "text",
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
      fontSize: 6,
    },
    h2: {
      color: "text",
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
      fontSize: 5,
    },
    h3: {
      color: "text",
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
      fontSize: 4,
    },
    p: {
      color: "text",
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body",
    },
    a: {
      color: "primary",
      textDecoration: "none",
      ":hover": {
        textDecoration: "underline",
      },
    },
  },
}

export default theme
